import { render } from "./App.vue?vue&type=template&id=8c0b35bc"
const script = {}

import "./App.vue?vue&type=style&index=0&id=8c0b35bc&lang=scss"

import exportComponent from "/Users/murtadha/Library/Mobile Documents/com~apple~CloudDocs/Murtadha/SKOLAN/KTH2020 Ingenjör /KTH Högskoleingenjörsdatateknik, Kista/År 2/II1302Projekt och projektmetoder/Morse-Mate/II1302/homepage/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__